import { render, staticRenderFns } from "./RegistryWizardIcon.vue?vue&type=template&id=67f2d237&scoped=true&"
var script = {}
import style0 from "./RegistryWizardIcon.vue?vue&type=style&index=0&id=67f2d237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2d237",
  null
  
)

export default component.exports